import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark-surface border-t border-dark-border">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* About Section */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Let's Try Bet</h3>
            <p className="text-dark-muted text-sm mb-4">
              Votre guide expert pour les meilleures offres de paris sportifs en France.
              Comparez, choisissez et gagnez avec les meilleurs bookmakers.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Liens rapides</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-dark-muted hover:text-accent-primary transition-colors text-sm"
                >
                  Accueil
                </Link>
              </li>
              <li>
                <Link
                  to="/comparaison"
                  className="text-dark-muted hover:text-accent-primary transition-colors text-sm"
                >
                  Comparaison
                </Link>
              </li>
              <li>
                <Link
                  to="/a-propos"
                  className="text-dark-muted hover:text-accent-primary transition-colors text-sm"
                >
                  À propos
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="text-dark-muted hover:text-accent-primary transition-colors text-sm"
                >
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Légal</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/politique-confidentialite"
                  className="text-dark-muted hover:text-accent-primary transition-colors text-sm"
                >
                  Politique de confidentialité
                </Link>
              </li>
              <li>
                <Link
                  to="/cookies"
                  className="text-dark-muted hover:text-accent-primary transition-colors text-sm"
                >
                  Politique des cookies
                </Link>
              </li>
              <li>
                <Link
                  to="/conditions"
                  className="text-dark-muted hover:text-accent-primary transition-colors text-sm"
                >
                  Conditions d'utilisation
                </Link>
              </li>
            </ul>
          </div>

          {/* Responsible Gaming */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Jeu responsable</h3>
            <div className="flex flex-wrap gap-4 mb-4">
              {[
                {
                  name: 'anj',
                  image: 'anj.webp',
                  url: 'https://anj.fr/',
                  alt: 'ANJ - Autorité Nationale des Jeux',
                },
                {
                  name: 'jouns',
                  image: 'jouns.webp',
                  url: 'https://www.hippodromesenfete.fr/jouons-responsable/',
                  alt: 'Jouons Responsable',
                },
                {
                  name: 'arjel',
                  image: 'arjel.webp',
                  url: 'https://www.data.gouv.fr/en/organizations/autorite-de-regulation-des-jeux-en-ligne-arjel/',
                  alt: 'ARJEL - Autorité de Régulation des Jeux en Ligne',
                },
                {
                  name: 'mediater',
                  image: 'mediater.webp',
                  url: 'https://mediateurdesjeuxenligne.fr/',
                  alt: 'Médiateur des Jeux en Ligne',
                },
                {
                  name: 'begamble',
                  image: 'begamble.webp',
                  url: 'https://www.gambleaware.org/',
                  alt: 'BeGambleAware',
                },
              ].map((org) => (
                <a
                  key={org.name}
                  href={org.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block opacity-70 hover:opacity-100 transition-opacity"
                  aria-label={org.alt}
                >
                  <img
                    src={`/images/footer/${org.image}`}
                    alt={org.alt}
                    className="h-8 w-auto"
                    loading="lazy"
                  />
                </a>
              ))}
            </div>
            <p className="text-dark-muted text-xs">
              Jeu responsable. 18+ seulement. Jouez avec modération.
            </p>
          </div>
        </div>

        <div className="border-t border-dark-border pt-8 text-center">
          <p className="text-dark-muted text-sm">
            © {currentYear} Let's Try Bet. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

